import { Clock } from "@phosphor-icons/react";
import { cn as classJoin } from "../../lib/utils";

const fmt = (v) => v == null ? "—" : `${v}d`;

export default function CycleTimeTile({ label, data }) {
    return (
        <div className="reedos-card p-4 hover:border-slate-900 transition-colors h-full" data-testid={`cycle-tile-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="reedos-eyebrow flex items-center gap-1.5"><Clock size={11} /> {label}</div>
            <div className="font-display font-bold reedos-data text-2xl mt-1 text-slate-900 leading-none">{fmt(data.median)}</div>
            <div className="text-[10px] text-slate-500 mt-1.5">median · n={data.n}</div>
            <div className="grid grid-cols-2 gap-2 mt-2 pt-2 border-t border-slate-100">
                <div>
                    <div className="reedos-eyebrow text-[9px]">P25</div>
                    <div className={classJoin("reedos-data text-sm font-semibold text-slate-700")}>{fmt(data.p25)}</div>
                </div>
                <div>
                    <div className="reedos-eyebrow text-[9px]">P75</div>
                    <div className="reedos-data text-sm font-semibold text-slate-700">{fmt(data.p75)}</div>
                </div>
            </div>
        </div>
    );
}
